import axios from 'axios';
import { stores } from '../stores';

export function createClient(config, noErrorHandling) {
  const client = axios.create(config);

  client.interceptors.response.use(
    (response) => response,
    (error) => {
      if (!noErrorHandling) {
        stores.uiStore.handleError(error);
      } else {
        console.warn("this API is configured to do not show a modal in case of errors")
      }
      throw error;
    },
  );

  return client;
}
